export const SIDEBAR_SCROLL_STORAGE_KEY = "sgrc.sidebar.scrollTop";
export const LEGACY_SIDEBAR_SCROLL_STORAGE_KEY = "sidebar-scroll-position";

export function parseSidebarScrollPosition(value) {
  const parsed = Number.parseInt(value, 10);
  if (!Number.isFinite(parsed) || parsed < 0) return 0;
  return parsed;
}

function readStorageItem(storage, key) {
  try {
    return storage?.getItem?.(key) ?? null;
  } catch {
    return null;
  }
}

function writeStorageItem(storage, key, value) {
  try {
    storage?.setItem?.(key, value);
  } catch {
    // Private mode / disabled storage should not break navigation.
  }
}

function removeStorageItem(storage, key) {
  try {
    storage?.removeItem?.(key);
  } catch {
    // ignore
  }
}

export function readSidebarScrollPosition(storage = globalThis.sessionStorage) {
  return parseSidebarScrollPosition(readStorageItem(storage, SIDEBAR_SCROLL_STORAGE_KEY));
}

export function writeSidebarScrollPosition(scrollTop, storage = globalThis.sessionStorage) {
  writeStorageItem(
    storage,
    SIDEBAR_SCROLL_STORAGE_KEY,
    String(parseSidebarScrollPosition(scrollTop)),
  );
}

export function clearSidebarScrollPosition(storage = globalThis.sessionStorage) {
  removeStorageItem(storage, SIDEBAR_SCROLL_STORAGE_KEY);
}

export function forgetLegacySidebarScrollPosition(storage = globalThis.localStorage) {
  removeStorageItem(storage, LEGACY_SIDEBAR_SCROLL_STORAGE_KEY);
}

export function getSidebarMaxScroll(element) {
  if (!element) return 0;
  return Math.max(0, (element.scrollHeight || 0) - (element.clientHeight || 0));
}

export function shouldIgnoreTransientSidebarScroll(element, savedScrollTop) {
  return getSidebarMaxScroll(element) <= 1 && parseSidebarScrollPosition(savedScrollTop) > 0;
}

export function resolveAppliedSidebarScroll(element, target) {
  const next = parseSidebarScrollPosition(target);
  if (!element) return null;
  const maxScroll = getSidebarMaxScroll(element);
  // Empty / collapsed content would clamp a real offset to 0 — wait for layout.
  if (next > 0 && maxScroll <= 1) return null;
  return Math.min(next, maxScroll);
}

export function applySidebarScroll(element, target) {
  const resolved = resolveAppliedSidebarScroll(element, target);
  if (resolved == null) return false;
  element.scrollTop = resolved;
  return Math.abs((element.scrollTop || 0) - resolved) <= 1;
}
